export default "__VITE_ASSET__C98D6dv$__"